"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _brandSelection = require("@/api/brandSelection");
var _activityPop = _interopRequireDefault(require("./components/activityPop.vue"));
var _brandPop = _interopRequireDefault(require("./components/brandPop.vue"));
var _resultPop = _interopRequireDefault(require("./components/resultPop.vue"));
var _goodsPop = _interopRequireDefault(require("./components/goodsPop.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  components: {
    activityPop: _activityPop.default,
    brandPop: _brandPop.default,
    resultPop: _resultPop.default,
    goodsPop: _goodsPop.default
  },
  data: function data() {
    return {
      total: 0,
      categoryOption: [],
      categoryName: '',
      dialogVisible: false,
      tableData: [],
      categoryData: [],
      queryData: {
        page: 1,
        size: 10,
        categoryId: '',
        brandName: '',
        status: ''
      }
    };
  },
  created: function created() {
    this.onInquire();
  },
  methods: {
    goodsAdmin: function goodsAdmin(val) {
      this.$refs.goodsPop.open({
        brandId: val.id,
        taskId: val.taskId
      });
    },
    result: function result(val) {
      this.$refs.resultPop.open({
        taskId: val.taskId
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.size = val;
      this.onInquire();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page = val;
      this.onInquire();
    },
    addBrand: function addBrand() {
      this.$refs.brandPop.open({
        type: 'add'
      });
    },
    detail: function detail(val) {
      this.$refs.brandPop.open((0, _objectSpread2.default)({
        type: 'upDate'
      }, val));
    },
    activityAdmin: function activityAdmin() {
      var _this = this;
      (0, _brandSelection.get_act)({}).then(function (res) {
        _this.$refs.activityPop.open({
          bgColor: res.data.bgColor,
          picUrl: res.data.picUrl
        });
      });
    },
    handleClose: function handleClose() {
      this.categoryName = '';
      this.dialogVisible = false;
      this.categoryData = [];
    },
    del_category: function del_category(val, index) {
      var _this2 = this;
      console.log(val, index);
      var h = this.$createElement;
      this.$msgbox({
        title: '提示',
        message: h('p', null, [h('span', {
          style: 'color: red'
        }, '风险提示！删除类目后，该类目下所有商品将被一并删除，且无法恢复。 '), h('p', "\u8BE5\u7C7B\u76EE\u4E0B\u5F53\u524D\u5171\u6709 ".concat(val.goodsCount, " \u4EF6\u5546\u54C1\uFF0C\u662F\u5426\u786E\u8BA4\u5220\u9664\uFF1F"))]),
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: function beforeClose(action, instance, done) {
          if (action === 'confirm') {
            if (val.id) {
              (0, _brandSelection.dels_category)({
                id: val.id
              }).then(function (res) {
                if (res.data) {
                  _this2.$message({
                    message: '操作成功！',
                    type: 'success'
                  });
                  _this2.getCategoryList();
                  done();
                }
              });
            } else {
              _this2.categoryData.splice(index, 1);
              done();
            }
          } else {
            done();
          }
        }
      }).then(function (action) {});
    },
    showCategoryPop: function showCategoryPop() {
      this.dialogVisible = true;
      this.getCategoryList();
    },
    getCategoryList: function getCategoryList() {
      var _this3 = this;
      (0, _brandSelection.get_category)({
        categoryName: this.categoryName
      }).then(function (res) {
        res.data.map(function (i) {
          i['showIpt'] = false;
        });
        _this3.categoryData = res.data;
      });
    },
    saveCategory: function saveCategory(val) {
      var _this4 = this;
      if (val.showIpt) {
        (0, _brandSelection.save_category)((0, _objectSpread2.default)({}, val)).then(function (res) {
          if (res.data) {
            _this4.$message({
              message: '操作成功！',
              type: 'success'
            });
            _this4.getCategoryList();
          }
        });
      } else {
        val.showIpt = true;
      }
    },
    categoryAdd: function categoryAdd() {
      this.categoryData.push({
        id: '',
        categoryName: '',
        sort: '',
        showIpt: true,
        goodsCount: 0
      });
    },
    categorySearch: function categorySearch() {
      this.getCategoryList();
    },
    categoryReset: function categoryReset() {
      this.categoryName = '';
      this.getCategoryList();
    },
    get_categoryselect: function get_categoryselect() {
      var _this5 = this;
      (0, _brandSelection.categoryselect)({}).then(function (res) {
        _this5.categoryOption = res.data;
      });
    },
    selcetShow: function selcetShow(val) {
      if (val) {
        this.get_categoryselect();
      }
    },
    del: function del(val) {
      var _this6 = this;
      this.$confirm('是否确认删除此品牌?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _brandSelection.del_brand)({
          id: val.id
        }).then(function (res) {
          if (res.data) {
            _this6.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
            _this6.onInquire();
          }
        });
      });
    },
    allChange: function allChange(val) {
      var _this7 = this;
      console.log(val);
      this.$confirm(val.status === 1 ? '是否确认上架该品牌?' : '是否确认下架该品牌?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _brandSelection.save_brand)({
          opType: 2,
          id: val.id,
          status: val.status
        }).then(function (res) {
          if (res.data) {
            _this7.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
            _this7.onInquire();
          }
        });
      }).catch(function () {
        if (val['status'] === 1) {
          val['status'] = 0;
        } else {
          val['status'] = 1;
        }
      });
    },
    onInquire: function onInquire() {
      var _this8 = this;
      (0, _brandSelection.get_brand)((0, _objectSpread2.default)({}, this.queryData)).then(function (res) {
        _this8.tableData = res.data.data;
        _this8.total = res.data.total;
      });
    },
    onInitialize: function onInitialize() {
      this.queryData = {
        page: 1,
        size: 10,
        categoryId: '',
        brandName: '',
        status: ''
      };
      this.onInquire();
    }
  }
};